<template>
  <dropdown
    :id="id"
    ref="dropdown"
    button-class="btn btn-light btn-sm dropdown-toggle"
    container-class="dropdown-light action-dropdown"
    :horizontal-position="position"
    menu-element="div"
  >
    <span slot="label"> {{ label }} <span class="caret"></span> </span>
    <slot></slot>
  </dropdown>
</template>

<script>
import { Dropdown } from 'vue-bootstrap';

export default {
  components: {
    Dropdown
  },
  props: {
    id: {
      type: String,
      default: 'action-dropdown'
    },
    label: {
      type: String,
      default: 'Action'
    },
    position: {
      type: String,
      default: 'left'
    }
  },
  methods: {
    close() {
      this.$refs.dropdown.close();
    }
  }
};
</script>
